var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.exportData}},[_vm._v("Download file")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.sheetx}},[_vm._v("x file")])])
}
var staticRenderFns = []

export { render, staticRenderFns }